import React from 'react';
import {Redirect, Switch} from 'react-router-dom';
import {useEffect} from 'react';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Route from './route';
import Symptom from './symptom';
import Followup from './followup';
import Condition from './condition';
import HealthcareFacility from './healthcare-facility';
import HealthcareFacilityLevel from './healthcare-facility-level';
import Driver from './driver';
import Village from './village';
import Payment from './payment';
import Ambulance from './ambulance';
import Region from './region';
import DspatchCenter from './dispatchCenter';
import VillageRoutes from './village-route'
import GeofenceRoutes from './geofence-route'
import VehicleType from './vehicleType';
import IncidentReport from './incident-report';
import RejectionReasonsDriver from './rejection-reason';
import RejectionReasonsHF from './rejection-reason-hf';
import RejectionReasonsAmbulance from './rejection-reason-ambulance';
import CaseManagement from './case-management';
import {IRootState} from 'app/shared/reducers';
import {connect} from 'react-redux';
import {getMMamaSettingsByCountryID} from 'app/modules/administration/mmama-settings/mmama-settings.reducer';
import TransferReason from "app/entities/transfer-reason";
import RegionDescription from "app/entities/region-description";
import Registration from 'app/entities/registration/registration';
import DispatcherDashboard from 'app/entities/dispatcher-dashboard';
import MmamaEntity from "app/entities/mmama-entity";


// eslint-disable-next-line
const Routes = ({ match, permissionSettings, userRoles, userCountryId, countrySettings, getMMamaSettingsByCountryID }) => {

  useEffect(() => {
    if (userCountryId && (countrySettings === null || countrySettings?.countryId !== userCountryId)) {
      getMMamaSettingsByCountryID(userCountryId);
    }
  }, [userCountryId]);

  // Don't render routes until user roles and permission settings are loaded
  // This is to prevent redirecting to home page when user refreshes the page
  if (!userRoles || !permissionSettings || permissionSettings.length === 0 || countrySettings?.countryId !== userCountryId) {
    return <div>Loading...</div>;
  }

  const array = [];
  const finalPermissions = permissionSettings
                            .filter((item:any) => item.role === userRoles[0])
                            .map((item:any) => {return {[item.role] : item.permissions}});

  finalPermissions.map((item: any) => {
      array.push(...Object.values(item))
  })

  console.log("ALL PERMISSIONS>>", userRoles, permissionSettings, finalPermissions , array[0]?.includes("ROUTES_VIEW"));

  return (
  <div>
    <Switch>
      {/* prettier-ignore */}
      {(array[0]?.includes("AMBULANCE_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}ambulance`} component={Ambulance} /> }
      {(array[0]?.includes("DRIVER_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}driver`} component={Driver} />}
      {(array[0]?.includes("FACILITY_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}healthcare-facility`} component={HealthcareFacility} />}
      {(array[0]?.includes("FACILITY_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}healthcare-facility-level`} component={HealthcareFacilityLevel} />}
      {(array[0]?.includes("PAYMENTS_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}payment`} component={Payment} />}
      {(array[0]?.includes("ROUTES_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}route`} component={Route} />}
      {(array[0]?.includes("SYMPTOM_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}symptom`} component={Symptom} />}
      {(array[0]?.includes("FOLLOWUP_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}condition`} component={Condition} />}
      {(array[0]?.includes("FOLLOWUP_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}followup`} component={Followup} />}
      {(array[0]?.includes("VEHICLE_TYPE_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}vehicle-type`} component={VehicleType} />}
      {(array[0]?.includes("VILLAGE_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}village`} component={Village} />}
      {(array[0]?.includes("REGION_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}region`} component={Region} />}
      {(array[0]?.includes("VILLAGE_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}region-description`} component={RegionDescription} />}
      {(array[0]?.includes("DISPATCH_CENTER_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}dispatch-center`} component={DspatchCenter} />}
      {(array[0]?.includes("ROUTES_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}village-routes`} component={VillageRoutes} />}
      {(array[0]?.includes("ROUTES_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}geofence-routes`} component={GeofenceRoutes} />}
      {(array[0]?.includes("INCIDENT_REPORT_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}incident-report`} component={IncidentReport} />}
      {(array[0]?.includes("REJECTION_REASON_DRIVER_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}rejection-reasons-driver`} component={RejectionReasonsDriver} />}
      {(array[0]?.includes("REJECTION_REASON_HF_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}rejection-reasons-hf`} component={RejectionReasonsHF} />}
      {(array[0]?.includes("REJECTION_REASON_AMBULANCE_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}rejection-reasons-ambulance`} component={RejectionReasonsAmbulance} />}
      {(array[0]?.includes("ROUTES_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}transfer-reason`} component={TransferReason} />}
      {(array[0]?.includes("CASE_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}case-management`} component={CaseManagement} />}
      {(array[0]?.includes("DISPATCHER_DASHBOARD_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}registration`} component={Registration} />}
      {(userRoles[0] === "ADMIN" || (array[0]?.includes("DISPATCHER_DASHBOARD_VIEW") && countrySettings?.dispatcherDashboardEnabled)) && <ErrorBoundaryRoute path={`${match.url}dispatcher-dashboard`} component={DispatcherDashboard} />}
      {(array[0]?.includes("ENTITIES_VIEW") || userRoles[0] === "ADMIN") && <ErrorBoundaryRoute path={`${match.url}mmama-entity`} component={MmamaEntity} />}
      <Redirect to={{pathname: "/"}} />
    </Switch>
  </div>
)};

const mapStateToProps = (storeState: IRootState) => ({
  permissionSettings: storeState.permissionSettings.settings,
  userRoles: storeState.authentication.account.roles,
  userCountryId: storeState.authentication.userCountryId,
  countrySettings: storeState.mmamaSettings.settingsDetail,
});

const mapDispatchToProps = {  getMMamaSettingsByCountryID };

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
